import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {LifeProjectBaseEditorComponent} from '../life-project-base-editor/life-project-base-editor.component';
import {UniversityProject} from '../../../../class/lifeproject/university-project';
import {WelfareResultService} from '../../../../service/welfare-result.service';
import {Person} from '../../../../class/person';
import {NbCheckboxComponent, NbDialogService} from '@nebular/theme';
import {UniversityPlan} from '../../../../class/config/university-plan';
import {Util} from '../../../../util/util';

@Component({
  selector: 'app-university-editor',
  templateUrl: './university-editor.component.html',
  styleUrls: ['./university-editor.component.css']
})
export class UniversityEditorComponent extends LifeProjectBaseEditorComponent implements OnInit {

  @Input()
  uniProject: UniversityProject;

  @ViewChild('checkboxComponent')
  checkboxComponent: NbCheckboxComponent;

  @ViewChild('dialog')
  dialog: TemplateRef<any>;

  private fixedAge = 19;
  uniPlans: UniversityPlan[] = [];


  constructor(welfareService: WelfareResultService, private dialogService: NbDialogService) {
    super(welfareService);
  }

  ngOnInit() {
    this.uniPlans = this.serviceProject.universityPlans;
  }

  getChildren(): Person[] {
    const children: Person[] = [];
    this.serviceProject.persons.forEach(person => {
      if (person.kind === 'CHILD') {
        children.push(person);
      }
    });

    return children;
  }

  getLifeProjectImpl() {
    return this.uniProject;
  }

  isValidChild(): boolean {
    let ret = false;

    if (this.uniProject) {
      if (this.uniProject.child) {
        if (this.uniProject.child.age != null) {
          ret = (this.fixedAge - this.uniProject.child.age) >= 0;
        }
      }
    }

    return ret;
  }

  get selectedChild() {
    return this.uniProject.child;
  }

  updateChild(person: Person) {
    this.uniProject.child = person;

    if (this.uniProject.child.age === 0) {

      // get current year
      const currentYear = Util.getCurrentYear();

      // get birthday year
      const birthdayYear = Util.stringToDate(this.uniProject.child.birthDay);

      this.uniProject.child.age = currentYear - birthdayYear.getFullYear();
    }

    this.uniProject.yearToGoal = (this.fixedAge - this.uniProject.child.age);
    if (!this.isValidChild()) {
      this.showErrorDialog(this.dialog);
      this.uniProject.yearToGoal = 0;
      this.uniProject.totalCost = 0;
      this.uniProject.yearCost = 0;
    }
  }

  calcTot() {

    if(!this.uniProject.tax){
      this.uniProject.tax = 0;
    }

    if(!this.uniProject.savedMoney){
      this.uniProject.savedMoney = 0;
    }

    const i = this.uniProject.tax / 100;

    if (i > 0) {

      const year = this.uniProject.yearToGoal > 0 ? this.uniProject.yearToGoal : 0;
      let currency = this.uniProject.selectedPlan.currency;

      if (!this.uniProject.savedMoney) {
        this.uniProject.savedMoney = 0;
      }

      if (this.checkboxComponent.checked) {
        const futureAccumulated = this.uniProject.savedMoney * Math.pow(1 + i, year);
        currency -= futureAccumulated;
      }

      this.uniProject.yearCost = currency * i / (Math.pow(1 + i, year) - 1);

    } else {
      // tslint:disable-next-line:max-line-length
      this.uniProject.yearCost = Math.round((this.uniProject.selectedPlan.currency - this.uniProject.savedMoney) / this.uniProject.yearToGoal);
    }

    this.uniProject.totalCost = this.uniProject.selectedPlan.currency - this.uniProject.savedMoney;
  }

  get totalCost() {
    return this.uniProject.totalCost;
  }

  showErrorDialog(dialog: TemplateRef<any>) {
    this.dialogService.open(dialog, {context: 'Attenzione eta del figlio selezionato non valida'});
  }

  updateSavedValue(check: boolean) {
    if (!check) {
      this.uniProject.savedMoney = 0;
    }
  }
}
